<template>
  <div class="card bg-white border-0">
    <div class="card-body p-25">
      <Form @submit="addValidationTask" :validation-schema="schema">
        <div class="row">

          <div class="col-12 mb-4">
            <label class="fw-semibold">Tâche spécifique au dossier ? <span class="text-danger">*</span></label>
            <Field name="is_specific" v-slot="{ field,handleChange  }">
              <div class="d-flex gap-3 mt-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    :name="field.name"
                    :value="false"
                    :checked="isSpecificValue === false"
                    @change="() => { isSpecificValue = false; handleChange(false); }"
                    id="specific_no"
                  />
                  <label class="form-check-label fw-medium" for="specific_no">
                    Non (file de validation)
                  </label>
                </div>

                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    :name="field.name"
                    :value="true"
                    :checked="isSpecificValue === true"
                    @change="() => { isSpecificValue = true; handleChange(true); }"
                    id="specific_yes"
                  />
                  <label class="form-check-label fw-medium" for="specific_yes">
                    Oui (dossier spécifique)
                  </label>
                </div>
              </div>
            </Field>
            <ErrorMessage name="is_specific" class="text-danger" />
          </div>

           <div class="col-md-6 mb-3">
            <label class="fw-semibold">libelle Tâche <span class="text-danger">*</span></label>
            <Field name="libelle" v-slot="{ field }">
              <input type="libelle" class="form-control" v-bind="field" />
            </Field>
            <ErrorMessage name="libelle" class="text-danger" />
          </div>

          <div class="col-md-6 mb-3" v-show="!isSpecificValue">
            <label class="fw-semibold">File de validation <span class="text-danger">*</span></label>
            <Field name="validationqueue" v-slot="{ field }">
              <Multiselect 
                v-bind="field" 
                v-model="field.value" 
                :options="queueOptions" 
                label="label" 
                track-by="value"
                placeholder="Sélectionner la file de validation" 
                searchable 
              />
            </Field>
            <ErrorMessage name="validationqueue" class="text-danger" />
          </div>

          <div class="col-md-6 mb-3" v-show="isSpecificValue">
            <label class="fw-semibold">Dossier BESC <span class="text-danger">*</span></label>
            <Field name="besc" v-slot="{ field }">
              <Multiselect 
                v-bind="field" 
                v-model="field.value" 
                :options="bescOptions" 
                label="label" 
                track-by="value"
                placeholder="Sélectionner le BESC" 
                searchable 
                show-labels 
              />
            </Field>
            <ErrorMessage name="besc" class="text-danger" />
          </div>

          <div class="col-md-6 mb-3">
            <label class="fw-semibold">Priorité <span class="text-danger">*</span></label>
            <Field name="priority" v-slot="{ field }">
              <Multiselect 
                v-bind="field" 
                v-model="field.value" 
                :options="priorityOptions" 
                label="label"
                track-by="value" 
                placeholder="Sélectionner la priorité" 
              />
            </Field>
            <ErrorMessage name="priority" class="text-danger" />
          </div>

          <!-- Agent assigné (si OUI) -->
          <div class="col-md-6 mb-3" v-show="isSpecificValue">
            <label class="fw-semibold">Agent assigné <span class="text-danger">*</span></label>
            <Field name="user" v-slot="{ field }">
              <Multiselect 
                v-bind="field" 
                v-model="field.value" 
                :options="userOptions" 
                label="label" 
                track-by="value"
                placeholder="Sélectionner l'agent assigné" 
                searchable 
                clearable 
              />
            </Field>
            <ErrorMessage name="user" class="text-danger" />
          </div>

          <div class="col-md-6 mb-3">
            <label class="fw-semibold">Date limite de traitement (SLA) <span class="text-danger">*</span></label>
            <Field name="sla_due_at" v-slot="{ field }">
              <input type="date" class="form-control" v-bind="field" />
            </Field>
            <ErrorMessage name="sla_due_at" class="text-danger" />
          </div>

          <div class="col-12 mb-3">
            <label class="fw-semibold">Description de la tâche</label>
            <Field name="description" v-slot="{ field }">
              <textarea 
                class="form-control" 
                v-bind="field" 
                rows="4"
                placeholder="Décrivez précisément la tâche à effectuer (ex: Vérifier les scellés, Contrôler les documents douaniers, etc.)..."
              ></textarea>
            </Field>
            <ErrorMessage name="description" class="text-danger" />
          </div>

          <div class="col-12 mt-4">
            <div class="card border-primary shadow-sm">
              <div class="card-header text-white d-flex justify-content-between align-items-center" style="background: linear-gradient(135deg, #0a59a4 0%, #0d6ebd 100%);">
                <div>
                  <h5 class="mb-0 text-white" >
                    <i class="fas fa-check-circle me-2"></i>
                    Liste des contrôles (Checks)
                  </h5>
                  <small class="opacity-75">Définissez les contrôles à effectuer pour cette tâche</small>
                </div>
                <button
                  type="button"
                  class="btn btn-light btn-sm"
                  @click="addCheck"
                  title="Ajouter un contrôle"
                >
                  <i class="fas fa-plus-circle me-1"></i>
                  Ajouter un check
                </button>
              </div>

              <div class="card-body p-3">
                <div class="row fw-bold text-muted mb-2 d-none d-md-flex">
                  <div class="col-md-3">Code du contrôle</div>
                  <div class="col-md-3">Titre</div>
                  <div class="col-md-2">Type</div>
                  <div class="col-md-3">Description</div>
                  <div class="col-md-1 text-center">Action</div>
                </div>
                <hr class="mt-0 mb-3" />

                <div v-if="checks.length === 0" class="text-center py-5 text-muted">
                  <i class="fas fa-clipboard-list fa-3x mb-3 opacity-50"></i>
                  <p class="mb-0">Aucun contrôle défini. Cliquez sur "Ajouter un check" pour commencer.</p>
                </div>

                <div v-for="(check, index) in checks" :key="index" class="mb-3">
                  <div class="card border">
                    <div class="card-body p-3">
                      <div class="row align-items-start">
                        
                        <div class="col-md-3 mb-2 mb-md-0">
                          <label class="d-block d-md-none fw-semibold small text-muted">Code</label>
                          <input
                            type="text"
                            v-model="check.check_code"
                            :class="{'form-control': true, 'is-invalid': validateCheck(check.check_code)}"
                            placeholder="Ex: DOC_INVOICE_PRESENT"
                          />
                          <div v-if="validateCheck(check.check_code)" class="text-danger small mt-1">
                            Le code est obligatoire
                          </div>
                        </div>

                        <div class="col-md-3 mb-2 mb-md-0">
                          <label class="d-block d-md-none fw-semibold small text-muted">Titre</label>
                          <input
                            type="text"
                            v-model="check.title"
                            :class="{'form-control': true, 'is-invalid': validateCheck(check.title)}"
                            placeholder="Ex: Facture commerciale fournie"
                          />
                          <div v-if="validateCheck(check.title)" class="text-danger small mt-1">
                            Le titre est obligatoire
                          </div>
                        </div>

                        <div class="col-md-2 mb-2 mb-md-0">
                          <label class="d-block d-md-none fw-semibold small text-muted">Type</label>
                          <Multiselect
                            v-model="check.check_type"
                            :options="checkTypeOptions"
                            label="label"
                            track-by="value"
                            placeholder="Type"
                            :class="{'is-invalid': validateCheck(check.check_type)}"
                          />
                          <div v-if="validateCheck(check.check_type)" class="text-danger small mt-1">
                            Le type est obligatoire
                          </div>
                        </div>

                        <div class="col-md-3 mb-2 mb-md-0">
                          <label class="d-block d-md-none fw-semibold small text-muted">Description</label>
                          <textarea
                            v-model="check.description"
                            class="form-control"
                            rows="2"
                            placeholder="Description détaillée..."
                          ></textarea>
                        </div>

                        <div class="col-md-1 text-center">
                          <label class="d-block d-md-none fw-semibold small text-muted">Action</label>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            @click="removeCheck(index)"
                            title="Supprimer ce contrôle"
                          >
                            <i class="flaticon-delete"></i>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                
              </div>
            </div>
          </div>

          <div class="col-12 mt-4">
            <button class="btn btn-success me-2" type="submit" :disabled="isSubmitting">
              <i class="fas fa-save me-1"></i>
              {{ isSubmitting ? 'Création en cours...' : 'Créer la tâche' }}
            </button>
            <router-link to="/listevalidationtasks" class="btn btn-outline-secondary">
              <i class="fas fa-times me-1"></i>Annuler
            </router-link>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed, watch, reactive } from "vue";
import { Form, Field, ErrorMessage, useForm } from "vee-validate";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import ApiService from "@/services/ApiService";
import { success, error } from "@/utils/utils";
import router from "@/router";

interface Option {
  value: string;
  label: string;
}

interface Check {
  check_code: string;
  title: string;
  check_type: string;
  description: string;
}

export default defineComponent({
  name: "ValidationTaskForm",
  components: { Form, Field, ErrorMessage, Multiselect },

  setup() {
    const { values, setFieldValue } = useForm();

    const priorityOptions: Option[] = [
      { value: "LOW", label: "Faible" },
      { value: "NORMAL", label: "Normale" },
      { value: "HIGH", label: "Élevée" },
      { value: "CRITICAL", label: "Critique" },
    ];

    const checkTypeOptions: Option[] = [
      { value: "MANUAL", label: "Manuel" },
     
    ];
   

    const bescOptions = ref<Option[]>([]);
    const queueOptions = ref<Option[]>([]);
    const userOptions = ref<Option[]>([]);

    const isSpecificValue = ref<boolean>(false);
    const isSubmitting = ref<boolean>(false);

    const checks = reactive<Check[]>([]);

    const addCheck = () => {
      checks.push({
        check_code: '',
        title: '',
        check_type: '',
        description: '',
      });
    };

    const removeCheck = (index: number) => {
      checks.splice(index, 1);
    };

    const validateCheck = (value: any): boolean => {
      return !value || value === '' || (typeof value === 'string' && value.trim() === '');
    };

    const validateAllChecks = (): boolean => {
      if (checks.length === 0) {
        error("Veuillez ajouter au moins un contrôle");
        return false;
      }

      for (let i = 0; i < checks.length; i++) {
        const check = checks[i];
        if (validateCheck(check.check_code) || validateCheck(check.title) || validateCheck(check.check_type)) {
          error(`Contrôle ${i + 1}: Veuillez remplir tous les champs obligatoires (Code, Titre, Type)`);
          return false;
        }
      }

      return true;
    };

    const schema = computed(() => {
      const baseSchema: any = {
        is_specific: Yup.boolean().required("Veuillez sélectionner une option"),
        libelle: Yup.string().required("Le libelle de la tâche est obligatoire"),
        priority: Yup.string().required("La priorité est requise"),
        sla_due_at: Yup.date().required("La date limite est requise"),
        description: Yup.string().nullable().max(1000, "Description trop longue (max 1000 caractères)"),
      };

      if (isSpecificValue.value) {
        baseSchema.besc = Yup.string().required("Le dossier BESC est requis");
        baseSchema.user = Yup.string().required("L'agent assigné est requis");
      } else {
        baseSchema.validationqueue = Yup.string().required("La file de validation est requise");
      }

      return Yup.object(baseSchema);
    });

   watch(isSpecificValue, (newVal) => {
      setFieldValue('is_specific', newVal);
      
      if (newVal) {
        setFieldValue('validationqueue', null);
      } else {
        setFieldValue('besc', null);
        setFieldValue('user', null);
      }
    });

    const addValidationTask = async (values: any) => {
      if (!validateAllChecks()) {
        return;
      }

      isSubmitting.value = true;

      const payload: any = {
        priority: values.priority,
        libelle: values.libelle,
        sla_due_at: values.sla_due_at,
        status: "PENDING",
        is_specific: isSpecificValue.value,
        description: values.description || null,
        checks: checks.map(check => ({
          check_code: check.check_code,
          title: check.title,
          check_type: check.check_type,
          description: check.description || null,
        })),
      };

      if (isSpecificValue.value) {
        payload.besc = { id: values.besc };
        payload.user = { id: values.user };
      } else {
        payload.validationqueue = { id: values.validationqueue };
      }

      console.log(" Payload envoyé:", payload); 

      try {
        const { data } = await ApiService.post("/validationt", payload);
        if (data.code === 201) {
          success(" Tâche de validation créée avec succès !");
          router.push({ name: "ListeValidationTaskPage" });
        }
      } catch (err: any) {
        console.error(" Erreur:", err);
        error(err.response?.data?.message || "Erreur lors de la création de la tâche");
      } finally {
        isSubmitting.value = false;
      }
    };

    onMounted(async () => {
      try {
         isSpecificValue.value = false;
        setFieldValue('is_specific', false);

        const bescRes = await ApiService.get("/bescsV");
        bescOptions.value = bescRes.data.data.data.map((b: any) => ({
          value: b.id,
          label: b.refbesc,
        }));

        const queuesRes = await ApiService.get("/validationqsss");
        queueOptions.value = queuesRes.data.data.data.map((q: any) => ({
          value: q.id,
          label: q.name,
        }));
        console.log("vallllll",queuesRes);

        const usersRes = await ApiService.get("/users");
        userOptions.value = usersRes.data.data.data.map((u: any) => ({
          value: u.id,
          label: `${u.nom} ${u.prenom}`,
        }));

        addCheck();

      } catch (e) {
        console.error(" Erreur chargement données:", e);
        error("Erreur lors du chargement des données");
      }
    });

    return {
      schema,
      bescOptions,
      queueOptions,
      userOptions,
      priorityOptions,
      checkTypeOptions,
      addValidationTask,
      isSpecificValue,
      isSubmitting,
      checks,
      addCheck,
      removeCheck,
      validateCheck,
    };
  },
});
</script>

<style scoped>
.card {
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Style pour les boutons */
.btn {
  transition: all 0.2s ease;
}

.btn:hover {
  transform: translateY(-1px);
}

/* Style pour les inputs invalides */
.is-invalid {
  border-color: #dc3545 !important;
}

/* Responsive pour mobile */
@media (max-width: 768px) {
  .card-body {
    padding: 1rem !important;
  }
  
  .row > div {
    margin-bottom: 1rem;
  }
}
</style>




